exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-divider__text{font-weight:700!important;font-size:16px!important}", ""]);

// exports
